<div class="layout-row-wrap gap-2px responsive-column">
  <div class="add-option">
    <h4 class="mat-h4">
      {{ 'labels.inputs.Market Price Period' | translate }}
      <i class="fas fa-question" matTooltip="{{ 'tooltips.Add future share value with date range' | translate }}"></i>
    </h4>

    <div class="">
      <button type="button" mat-raised-button color="primary" (click)="addMarketPricePeriod()">
        <fa-icon icon="plus" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Add' | translate }}
      </button>
    </div>
  </div>

  @if (marketPricePeriods.value.length) {
    <table class="flex-98 mat-elevation-z1" mat-table [dataSource]="marketPricePeriods.value">
      <ng-container matColumnDef="fromDate">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.From Date' | translate }}</th>
        <td mat-cell *matCellDef="let marketPricePeriod">
          {{ marketPricePeriod.fromDate | dateFormat }}
        </td>
      </ng-container>
      <ng-container matColumnDef="shareValue">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Nominal/Unit Price' | translate }}</th>
        <td mat-cell *matCellDef="let marketPricePeriod">
          {{ marketPricePeriod.shareValue }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
        <td mat-cell *matCellDef="let variation; let i = index">
          <button mat-icon-button color="primary" (click)="editMarketPricePeriod(i)">
            <fa-icon icon="edit"></fa-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteMarketPricePeriod(i)">
            <fa-icon icon="trash"></fa-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</div>

<div class="layout-row responsive-column align-center gap-2px margin-t">
  <button mat-raised-button matStepperPrevious>
    <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Previous' | translate }}
  </button>
  <button mat-raised-button matStepperNext>
    {{ 'labels.buttons.Next' | translate }}
    <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
  </button>
</div>
